import React from 'react';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../actions/appointmentActions.js';
import Condition from '../sitemanagement/condition';
import * as constant from '../../constants/constant.js';
import 'react-toastify/dist/ReactToastify.css';
import $ from "jquery";
import moment from 'moment';
class AppointmentConfirmation extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			isConfirm: false,
			appointmentDetails: {}, sunday: false,
			spinner:false,
			paymentMethod: 'card'
		}
		this.addAppointment = this.addAppointment.bind(this);
		this.onChange = this.onChange.bind(this);
		this.hideConditionModal = this.hideConditionModal.bind(this);
		this.acceptTermNCondition = this.acceptTermNCondition.bind(this);
		this.declineTermNCondition = this.declineTermNCondition.bind(this);
		this.conditionModalOpen = this.conditionModalOpen.bind(this);
		this.changeIn = this.changeIn.bind(this);
	}
	changeIn(event) {
		var state = this.state;
		if (event.target.name == "saturday" || event.target.name == "sunday" || event.target.name == "monday" || event.target.name == "tuesday" || event.target.name == "wednesday" || event.target.name == "thursday" || event.target.name == "friday") {
			let flag = (event.target.value == 'false' || event.target.value == '');
			state[event.target.name] = flag == true ? true : false;
			this.setState(state);
		} else {
			state[event.target.name] = event.target.value;
			this.setState(state);

		}
	}
	conditionModalOpen() {
		this.setState({ conditionModal: true, isConfirm: false });

	}
	acceptTermNCondition() {
		this.setState({ conditionModal: false, isConfirm: true });
	}
	declineTermNCondition() {
		this.setState({ conditionModal: false, isConfirm: false });
	}
	componentWillMount() {
		this.setState({ isLoader: false })
		let appointmentObj = {
			appointmentId: localStorage.getItem('appointmentId')
		}
		this.props.actions.getAppointmentDetails(appointmentObj);
		if (this.props.location.data && this.props.location.data.appointmentId)
		this.setState({
			isLoader: false,
			userCreatedBy: 'S'
		})

	}
	componentDidMount() {
	}
	componentWillReceiveProps(nextProps) {
		//  ;
		//nextProps.appointmentDetails._id
		this.setState({
			appointmentDetails: nextProps.appointmentDetails
		})
	}

	onChange(event) {
		event.preventDefault();
		var state = this.state;
		if (event.target.checked == true) {
			document.getElementById("isConfirm").checked = true;
			state.isConfirm = true;
			this.setState(state);
		}
		else {
			document.getElementById("isConfirm").checked = false;
			state.isConfirm = false;
			this.setState(state);
		}
	}

	addAppointment(event) {
		event.preventDefault()
		this.setState({ spinner: true })
		let isConfirm = this.state.isConfirm
		let appointmentId = localStorage.getItem('appointmentId');
		let addAppointmentObj = {
			isConfirm: this.state.paymentMethod == 'cash' ? true : isConfirm,
			appointmentId: appointmentId,
			paymentMethod: this.state.paymentMethod,
			appointmentMode: this.state.appointmentDetails.appointmentMode,
			userCreatedBy: this.state.userCreatedBy
		};
		this.props.actions.addAppointmentDetails(addAppointmentObj, this.props);

	}

	hideConditionModal() {
		this.setState({ conditionModal: false, isConfirm: false });
	}
	changePaymentMethod = (e) => {
		this.setState({
			paymentMethod: e.currentTarget.value
		})
	}

	render() {
		var appointmentDetails = this.state.appointmentDetails;
		var isCashDisabled = localStorage.getItem('clinicCountryZone') != moment.tz.guess() && appointmentDetails.appointmentMode == '2'
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		return (
			<div className="content-wrapper">

				{this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :



					<section className="content container-fluid">
						{/* <ToastContainer /> */}
						{/* <div className="row">
							<div className="col-md-5">
								<div className="boxMrgB">
									<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img//family_medicine.png')} alt="" /></i></span>
										<input type="" className="form-control" placeholder="Family Medicine" />
									</div>
								</div>
							</div>
							<div className="col-md-5">
								<div className="boxMrgB">
									<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/map_icon.png')} alt="" /></i></span>
										<input type="" className="form-control" placeholder="Family Medicine" />
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="boxMrgB">
									<button type="button" className="btn btn-block btn-warning btn-lg">Search</button>
								</div>
							</div>
						</div> */}
						<form name="appointmentConfirm-form" id="appointmentConfirm-form" onSubmit={this.addAppointment.bind(this)}>
							<div className="row">
								<div className="col-md-12">
									<div className="boxMrgB">
										<div className="nav-tabs-custom">
											<ul className="nav nav-tabs row">
												<li ><Link href="#tab_1" data-toggle="tab" className="active show">Confirm Details</Link></li>
												<li className=" col-md">
													<div className="content-header"><ol className="breadcrumb">
														<li><Link> Book Appointment</Link></li>
														<li><Link to="/book-appointment">Search Specialist</Link></li>
														<li><Link to="/book-appointment-calendar">Calendar</Link></li>
														<li><Link to='/appointment-details'>Appointment Details</Link></li>
														<li className="active">Confirm Details</li>
													</ol></div>

												</li>
											</ul>

											<div className="tab-content healthTips">
												<div className="tab-pane active" id="tab_1">
													<div className="row">
														<div className="col-md-12">
															<div className="userProImg userProAppConf">

																{appointmentDetails.profileImage == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={appointmentDetails.users[0].gender == 'Male' ?constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png':constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png' } alt="User profile picture" /> : appointmentDetails && appointmentDetails.users ? <img className="profile-user-img img-responsive img-circle" src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + appointmentDetails.users[0]._id + '/' + appointmentDetails.profileImage} alt="User profile picture" /> : ''}

																<h2 className="text-capitalize">Dr. {appointmentDetails ? appointmentDetails.users ? appointmentDetails.users[0].userName : '' : ''}</h2>
															</div>
														</div>
														<div className="col-md-6">
															<div className="appoConfirm"><i><img src={require('../../images/Duration.svg')} /></i> Duration : 30 Min</div>
														</div>
														<div className="col-md-6">
															<div className="appoConfirm"><i><img src={require('../../images/DateBooked.svg')} /></i> Date Booked : {appointmentDetails ? moment.parseZone(new Date(appointmentDetails.checkappointmentDate)).format('DD-MM-YYYY') : ''}</div>
															{/* {item ? moment(moment.utc(item.appointmentDate).toDate()).format('DD-MMM-YYYY') : ''} */}

														</div>
														<div className="col-md-6">
															<div className="appoConfirm"><i><img src={require('../../images/TimeBooked.svg')} /></i> Time Booked :  {appointmentDetails ? moment.parseZone(new Date(appointmentDetails.checkappointmentDate)).format('hh:mm A') + " " + userlocation: ''}
																{/* {item ? moment(moment.utc(item.appointmentDate, "h:mm:ss A").toDate()).format("HH:mm") : ''} */}
															</div>
														</div>
														<div className="col-md-6">
															<div className="appoConfirm"><i><img src={require('../../images/Mode.svg')} /></i> Mode : {appointmentDetails ? appointmentDetails.appointmentMode == '1' ? 'Face to face' : 'Online' : ''}</div>
														</div>
														<div className="col-md-6">
															<div className="appoConfirm capitalize marginrightapp"><i><img src={require('../../images/Address.svg')}/></i> Address : {appointmentDetails ? appointmentDetails.addressLineOne : ''} {appointmentDetails ? appointmentDetails.addressLineTwo : ''},
														{appointmentDetails ? appointmentDetails.city : ''},
														{appointmentDetails ? appointmentDetails.state : ''}, {appointmentDetails ? appointmentDetails.country : ''} {appointmentDetails ? appointmentDetails.zipCode : ''} </div>
														</div>
														<div className="col-md-6">
															<div className="appoConfirm sym-wrap" style={{ display: "block" }}><i style={{ float: "left" }}><img src={require('../../images/Symptoms.svg')} />	</i><div> Symptoms : </div> <span className="appointmentPatient-symptoms"> {appointmentDetails ? appointmentDetails.symptoms : ''}</span></div>
														</div>

														<div className="col-md-6">
															<div className="appoConfirm" style={{ display: "block", }}>
															<p className=""><i><img src={require('../../images/img/consultationfees_icon-grey.png')} alt="" /></i>Consultation fees: {appointmentDetails.fee} {appointmentDetails.Docavailabilities ? appointmentDetails.Docavailabilities[0].currencySymbol :''} </p> 
															</div>
														</div>
														<div className="col-md-6">
														<div class="appoConfirm">
															<p class="">
																<i><img src={require('../../images/img/consultationfees_icon-grey.png')} alt="" /></i>
																Payment Method:
															</p>
															<div class="radio radio-primary radio-period" style={{"margin-left": "19px", "margin-top": "-4px"}}>
																<input id="cash" type="radio" name="optradio" value="cash" disabled={appointmentDetails && appointmentDetails.appointmentMode == '2' || isCashDisabled } checked={this.state.paymentMethod == 'cash'} onChange={this.changePaymentMethod}/>
																<label htmlFor="cash">
																	Cash
																</label>
															</div>
															<div class="radio radio-primary radio-period" style={{"margin-left": "19px", "margin-top": "-4px"}}>
																<input type="radio" name="optradio" id="card" value="card" checked={this.state.paymentMethod == 'card'} onChange={this.changePaymentMethod}/>
																<label htmlFor="card">
																	Card
																</label>
															</div>
														</div>
														</div>


														<div className="col-md-6 offset-md-4">
															<div className="appoConfirm"> <div >
																<div className="checkbox checkbox-primary">
																	<input id="isConfirm" name="isConfirm" value={this.state.isConfirm} type="checkbox" onChange={this.onChange.bind(this)} checked={this.state.isConfirm == true ? true : false} disabled='true' />
																	{/* <div className="row"> */}
																	<label htmlFor="isConfirm">
																		I agree to the 	</label>
																	<span style={{ marginLeft: 6 }}>	<Link style={{ color: "#00B5E5", cursor: "pointer" }} onClick={this.conditionModalOpen.bind(this)}>Terms and Conditions</Link></span>
																	{/* </div> */}


																	{/* addddddddddddd {this.state.sunday}
																	<input type="checkbox" onChange={this.changeIn} value={this.state.sunday} name="sunday" id="sunday" checked={this.state.sunday && this.state.sunday == true ? true : ''} />

																	<div className="row">
																		<label htmlFor="sunday">
																			I agree to the 	</label>
																		<div style={{ marginLeft: 6 }}>	<Link style={{ color: "#00B5E5", cursor: "pointer" }} onClick={this.conditionModalOpen.bind(this)}>Terms and Conditions</Link></div>
																	</div> */}

																	{this.state.conditionModal ? <Condition openModal={this.state.conditionModal} hideConditionModal={this.hideConditionModal} acceptTerm={this.acceptTermNCondition.bind(this)} declineTerm={this.declineTermNCondition.bind(this)} /> : ''}
																</div>

															</div> </div>
														</div>

														<div className="col-md-12 text-center">
															<div className="boxMrgB btnBtm">
																<button type="submit" disabled={!this.state.isConfirm} className="btn btn-warning btn-lg btnBtm190" >Confirm {this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
															</div>
														</div>

														<div className="col-md-12 ">
															<p><strong>Cancellation Policy : Must give 24 hours</strong></p>
															<p>You may cancel your appointment upto 24 hours before the allocated time and receive full refund. HOWEVER : failure to give 24 hours
or not be at the agreed location and time will result in 50% of the consultation fees being charged. Please read our Terms and
Conditions for a complete Cancellation policy</p>
														</div>

													</div>
												</div>
											</div>

											{/* <div className="checkbox checkbox-primary checkboxInline">
												<input type="checkbox" name="radio1" id="checkbox1" value="option1" />
												<label for="checkbox1" className="startReview">
													<span>Monday</span>
												</label>

											</div> */}
										</div>

									</div>

								</div>

							</div>
						</form>
					</section>}

				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}
// export default BookAppointment;
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		appointmentDetails: state.appointment.appointmentDetails
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(AppointmentConfirmation);